<template>
  <div class="cart">
    <div class="reportBasic-subTitle">
      {{ $tc('lang.factoryReport.Production_Manufacturing_Process') }}
    </div>
    <div class="productProcess-list" v-for="(item, index) in data" :key="index">
      <div class="dian1">
        <span>{{ $tc('lang.factoryReport.Production_Line') }}：</span>
        <a-input v-model="item.factoryProduction.productionLine"></a-input>
      </div>
      <div class="dian1">
        <span>{{ $tc('lang.factoryReport.Automatization') }}：</span>
        <a-radio-group
          name="radioGroup"
          v-model="item.factoryProduction.productionAuto"
        >
          <a-radio value="1">{{
            $tc('lang.factoryReport.Full_automatic')
          }}</a-radio>
          <a-radio value="2">{{
            $tc('lang.factoryReport.Semi_automatic')
          }}</a-radio>
        </a-radio-group>
      </div>
      <div class="dian1">
        <span>{{ $tc('lang.factoryReport.Production_Line_Quantity') }}：</span>
        <a-input
          v-model="item.factoryProduction.productionLinenumber"
        ></a-input>
      </div>
      <div class="dian1">
        <span>{{ $tc('lang.factoryReport.Staff_Quantity') }}：</span>
        <a-input
          v-model="item.factoryProduction.productionStaffnumber"
        ></a-input>
      </div>
      <div class="dian1">
        <span>{{ $tc('lang.factoryReport.Yearly_Output') }}：</span>
        <a-input
          v-model="item.factoryProduction.productionYearoutput"
        ></a-input>
      </div>
      <div class="desOfGoods-con">
        <span>{{ $tc('lang.factoryReport.Production_Line') }}</span>
        <div class="img">
          <show-img
            :data="item.media"
            :otherData="{
              mediaName: '',
              mediaType: 3,
              personId: '',
              orderId: '',
              reportId: '',
              mediaDesc: '',
            }"
            :id="id"
          ></show-img>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import showImg from './showImg';

export default {
  data() {
    return {
      id: this.$route.query.id,
      data: [],
    };
  },
  computed: {
    factoryDetails: {
      get() {
        return JSON.parse(
          JSON.stringify(this.$store.state.report.factoryDetails),
        );
      },
    },
  },
  components: {
    showImg,
  },
  created() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      this.$http
        .post('/hzwmj/factory-production/seachFactoryProduction', {
          freportId: this.factoryDetails.freportId,
        })
        .then(data => {
          if (data.data) {
            this.data = data.data;
          } else {
            this.data = [];
          }
        })
        .catch(() => {
          this.data = [];
        });
    },
    handleSubmit(item) {
      const factoryProduction = item.factoryProduction;
      const media = [];
      item.media.forEach(item => {
        media.push(item.id);
      });
      let newData = [
        {
          ...factoryProduction,
          productionLinephoto: media.join(','),
        },
      ];
      this.$http
        .post('/hzwmj/factory-production/saveOrUpdateFactoryProduction', {
          data: newData,
        })
        .then(data => {
          if (data) {
            this.$message.success('保存成功');
            this.getDetail();
            // this.details = data;
          } else {
            this.$message.error('保存失败');
          }
        })
        .catch(() => {
          this.$message.error('保存失败');
        });
    },
  },
};
</script>
<style lang="less">
.cart {
  .productProcess-list {
    margin-bottom: 20px;
  }
  .desOfGoods-con {
    display: flex;
    margin-top: 30px;
    .button-group {
      width: 130px;
      flex-shrink: 0;
    }
    .img {
      flex-grow: 1;
    }
    > span {
      display: inline-block;
      width: 100px;
      flex-shrink: 0;
      padding-left: 20px;
    }
  }
  .desOfGoods-table {
    display: flex;
    .desOfGoods-table2 {
      flex-grow: 1;
      margin-left: 20px;
    }
    .desOfGoods-table3 {
      flex-grow: 1;
      margin-left: 20px;
    }
    .button-group {
      width: 130px;
      flex-shrink: 0;
    }
  }
  .dian1 {
    margin-bottom: 10px;
    > span:nth-child(1) {
      width: 120px;
      padding-left: 20px;
      display: inline-block;
    }
    input {
      width: 150px;
    }
    .ant-radio-group {
      width: 220px;
    }
  }
}
</style>
